import { Button } from "@mui/material";
import aboutusImg from '../assets/img/aboutus-page.jpg'
import { forwardRef } from "react";

export const AboutusSection = forwardRef(({func}, ref) =>{

    return(
        <>
            <section className="mainWrapper min-h-fit flex flex-col items-center justify-center py-[15vh] gap-10 " >
                <h4 className="header text-center capitalize font-medium" style={{textShadow:'2px 2px 5px rgba(0, 0, 0, 1)'}}>
                    about us
                </h4>
                <p className="subheader text-center leading-relaxed " style={{textShadow:'2px 2px 5px rgba(0, 0, 0, 0.6)'}}>
                    Unlock the power of the web and propel your business to new heights with Fade's visionary services. As Steve Jobs famously said, 'Innovation distinguishes between a leader and a follower.' Embrace innovation and lead the way in your industry with our cutting-edge solutions. Don't settle for ordinary – choose Fade solutions and dare to redefine excellence in the digital age.
                </p>
                <img src={aboutusImg} alt="learn about us" className="secTmg  w-full object-cover object-right" />
                <p className="subheader text-center leading-relaxed " style={{textShadow:'2px 2px 5px rgba(0, 0, 0, 0.6)'}}>
                    At Fade solutions, we’re not just a web and software design, development, and marketing agency – we’re your partners in innovation and growth. Operating entirely remotely from Nigeria, Africa, our extraordinary team is dedicated to preparing businesses of all sizes for the future. 
                    <br />
                    We craft user-friendly interfaces that not only communicate your brand’s essence but also drive your digital presence to new heights. 
                    <br />
                    What sets us apart? Our unwavering commitment to exceptional customer service and satisfaction. At Fade solutions, we don’t just deliver solutions; we guide you every step of the way on your journey to digital transformation. Let’s elevate your business together!
                </p>
                <Button variant="text" ref={ref}
                    sx={{color : '#FFFFFF', fontWeight:'600',
                        '&:hover': {color : '#FFFFFF', backgroundColor:'#141414' }
                    }}
                    onClick={func}
                >
                    <p>
                        contact us
                    </p>
                </Button>
            </section>
        </>
    )
})